export const SHOW_ERROR_NOTIFICATION = 'SHOW_ERROR_NOTIFICATION';

export const showErrorNotification = (message: string) => ({
    type: SHOW_ERROR_NOTIFICATION,
    payload: {
        message,
    }
});